import * as Yup from "yup";

import { IBasicEntity } from "../../../core/models";
import { IClient } from "../../client/data/entities";
import { IProduct } from "../../product/data/entities";
import { ETransactionType } from "./models";

export interface IProductTransactionForm {
  productId: string;
  dirtyWeight: number;
  cleanWeight: number;
  wastePercent: number;
  pricePerKg: number;
  amount: number;
}

export interface IProductTransaction extends IBasicEntity, IProductTransactionForm {
  product: IProduct;
  client: IClient;
  dirtyWeight: number;
  cleanWeight: number;
  wastePercent: number;
  pricePerKg: number;
  amount: number;
  type: ETransactionType.PRODUCT_BUY | ETransactionType.PRODUCT_SELL;
}

export interface IExpenseTransactionForm {
  expenseId: string;
  amount: number;
}

export interface IProductBuyBulkTransactionForm {
  clientId: string;
  productTransactions: IProductTransactionForm[];
  expenseTransactions: IExpenseTransactionForm[];
  type: ETransactionType.PRODUCT_BUY;
}

const productBuyTransactionCommonValidation = {
  clientId: Yup.string().required(),
  productTransactions: Yup.array<IProductTransactionForm>(
    Yup.object({
      productId: Yup.string().required(),
      dirtyWeight: Yup.number()
        .min(1)
        .required(),
      cleanWeight: Yup.number()
        .min(1)
        .required(),
      pricePerKg: Yup.number()
        .min(0)
        .required(),
      wastePercent: Yup.number()
        .min(0)
        .max(99)
        .required(),
      amount: Yup.number()
        .min(1)
        .required(),
    }),
  ),
  expenseTransactions: Yup.array<IExpenseTransactionForm>(
    Yup.object({
      expenseId: Yup.string().required(),
      amount: Yup.number()
        .min(1)
        .required(),
    }),
  ),
  type: Yup.mixed()
    .oneOf([ETransactionType.PRODUCT_BUY])
    .required(),
};

export const productBuyTransactionFormValidation = Yup.object<IProductBuyBulkTransactionForm>({
  ...productBuyTransactionCommonValidation,
});

// export const transactionEditFormValidation = Yup.object<IProductTransactionForm>({
//   ...productTransactionCommonValidation,
// });

export const productBuyTransactionToJson = (form: IProductBuyBulkTransactionForm) => {
  const productTransactions = form.productTransactions.map((t) => {
    return {
      client: {
        id: form.clientId,
      },
      product: {
        id: t.productId,
      },
      dirtyWeight: parseFloat(t.dirtyWeight.toString()),
      wastePercent: parseFloat(t.wastePercent.toString()),
      amount: parseFloat(t.amount.toString()),
      type: ETransactionType.PRODUCT_BUY,
    };
  });

  const expenseTransactions = form.expenseTransactions.map((t) => {
    return {
      client: {
        id: form.clientId,
      },
      expense: {
        id: t.expenseId,
      },
      amount: parseFloat(t.amount.toString()),
      type: ETransactionType.EXPENSE,
    };
  });

  return {
    bulk: [...productTransactions, ...expenseTransactions],
  };
};
